// [2026-10-29] หน้า "ยูฟ่า" — แบบเดียวกับเว็บลาว (Ufa11New): ปุ่มทางเข้าเล่น UFA + สำรอง 1/2
//   ทุกปุ่มเรียก /api/v1/tablauncher { gameId: 'sport', partner: 'uefa' } (เหมือนลาว: redeem(e, "sport", "uefa"))
//   ก่อนเข้าเกมเช็คกระเป๋า UFA (ufaGateBeforeLaunch) → ถ้าว่างให้ไปหน้าโยกเครดิตก่อน
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';
import instance from './axios-instance';
import Systems from './SystemFunction';
import { getWalletBalances, ufaGateBeforeLaunch } from './wallettransfer';

const fmt = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const C1 = 'var(--primary, #fbc844)';

export default class UfaLobby extends Component {
  state = { W: null, busy: '' };
  componentDidMount() { this.load(); }
  load = async () => {
    if (!localStorage.getItem('auth_token')) return;
    try { this.setState({ W: await getWalletBalances() }); } catch (e) { }
  };
  goTransfer = () => { if (this.props.onTransfer) this.props.onTransfer(); else window.location.href = '/transfer'; };

  play = async (key) => {
    const { loginstate, username } = this.props;
    if (!loginstate || !username) {
      await Swal.fire({ icon: 'warning', title: 'กรุณาเข้าสู่ระบบก่อนเล่น', confirmButtonText: 'ตกลง' });
      if (this.props.onLogin) this.props.onLogin();
      return;
    }
    if (!(await ufaGateBeforeLaunch('UEFA', this.goTransfer))) return;
    this.setState({ busy: key });
    try {
      const res = await instance.post('/api/v1/tablauncher', {
        gameId: 'sport', partner: 'uefa', playerUsername: username, isMobile, System: Systems, demo: false,
      });
      const launcher = res && res.data && res.data.status === 200 && res.data.message && res.data.message.launcher;
      if (!launcher) {
        Swal.fire({ icon: 'error', title: 'Error!', text: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่', confirmButtonText: 'ตกลง' });
        return;
      }
      const ua = navigator.userAgent;
      if (/iPad|iPhone|Macintosh|iPod/.test(ua) && !window.MSStream) window.location.href = launcher.mobile;
      else if (!isMobile) window.open(launcher.desktop, '_blank', 'height=1000,width=1000');
      else window.open(launcher.mobile);
    } catch (e) {
      Swal.fire({ icon: 'error', title: 'Error!', text: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่', confirmButtonText: 'ตกลง' });
    } finally { this.setState({ busy: '' }); }
  };

  render() {
    const { W, busy } = this.state;
    const btn = (key, label, main) => (
      <button type="button" key={key} className={'ufl-btn' + (main ? ' is-main' : '')} disabled={!!busy} onClick={() => this.play(key)}>
        {busy === key ? <span className="ufl-spin" /> : <span className="ufl-ico">⚽</span>}
        <span>{label}</span>
      </button>
    );
    return (
      <div className="ufl animated animatedFadeInUp fadeInUp">
        <style>{UFL_CSS}</style>
        <div className="ufl-wrap">
          <div className="ufl-hero">
            <img className="ufl-logo" src="/build/web/igame-index-lobby-wm/img/logo-ufabet.png" alt="UFA" />
            <div className="ufl-sub">เว็บแทงบอลออนไลน์ กีฬา คาสิโน ครบในที่เดียว</div>
            {W && W.ufaEnabled !== false ? (
              <div className="ufl-bal">
                <div><small>กระเป๋าหลัก</small><b>{fmt(W.main)} ฿</b></div>
                <div className="ufl-sep" />
                <div><small>กระเป๋า UFA</small><b style={{ color: C1 }}>{fmt(W.ufa)} ฿</b></div>
              </div>
            ) : null}
            <button type="button" className="ufl-transfer" onClick={this.goTransfer}>⇄ โยกเครดิต</button>
          </div>
          <div className="ufl-list">
            {btn('main', 'ทางเข้าเล่น UFA', true)}
            {btn('b1', 'ทางเข้าเล่น UFA (สำรอง 1)')}
            {btn('b2', 'ทางเข้าเล่น UFA (สำรอง 2)')}
          </div>
          <div className="ufl-note">* เล่น UFA ใช้เครดิตในกระเป๋า UFA — โยกเครดิตจากกระเป๋าหลักก่อนเข้าเล่น</div>
        </div>
      </div>
    );
  }
}

const UFL_CSS = `
.ufl{padding:8px 6px 90px;color:#fff}
.ufl-wrap{max-width:560px;margin:0 auto}
.ufl-hero{position:relative;text-align:center;border-radius:20px;padding:22px 16px 18px;margin-bottom:14px;overflow:hidden;
  background:radial-gradient(circle at 50% 30%,rgba(255,170,40,.55),transparent 60%),linear-gradient(160deg,#7a0000,#2a0000);
  border:1.5px solid rgba(251,200,68,.55);box-shadow:0 12px 30px rgba(0,0,0,.45)}
.ufl-logo{width:78%;max-width:340px;filter:drop-shadow(0 4px 10px rgba(0,0,0,.6)) brightness(1.15)}
.ufl-sub{font-size:13px;opacity:.85;margin-top:4px}
.ufl-bal{display:flex;justify-content:center;align-items:center;gap:14px;margin:14px auto 0;padding:10px 14px;border-radius:14px;background:rgba(0,0,0,.35);max-width:380px}
.ufl-bal small{display:block;font-size:11px;opacity:.75}
.ufl-bal b{font-size:18px}
.ufl-sep{width:1px;align-self:stretch;background:rgba(255,255,255,.2)}
.ufl-transfer{margin-top:12px;border:1px solid ${C1};background:rgba(0,0,0,.3);color:${C1};border-radius:999px;padding:6px 18px;font-weight:700;font-size:14px}
.ufl-list{display:flex;flex-direction:column;gap:10px}
.ufl-btn{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;height:54px;border-radius:14px;font-size:17px;font-weight:800;color:#fff;
  background:linear-gradient(160deg,rgba(255,255,255,.12),rgba(255,255,255,.04));border:1px solid rgba(255,255,255,.2);box-shadow:0 6px 16px rgba(0,0,0,.3);transition:.15s}
.ufl-btn:active{transform:scale(.98)}
.ufl-btn.is-main{height:60px;font-size:19px;color:#111;border:0;background:linear-gradient(180deg,#ffe58a,${C1})}
.ufl-btn:disabled{opacity:.7}
.ufl-ico{font-size:20px}
.ufl-spin{width:18px;height:18px;border:3px solid rgba(0,0,0,.25);border-top-color:currentColor;border-radius:50%;animation:uflspin .8s linear infinite}
@keyframes uflspin{to{transform:rotate(360deg)}}
.ufl-note{font-size:12px;opacity:.7;text-align:center;margin-top:12px}
`;
